import { EMPTY_TABLE_MESSAGES, VOUCHER_PRIMARY_VIEWS } from '../constants';

/**
 * Returns vouchers filtered by primary view and closed status.
 *
 * @param {Object} vouchersByStatus
 * @param {'active' | 'closed'} view
 * @param {'approved' | 'rejected'} [closedStatus]
 * @returns {Array}
 */
export function getVisibleVouchers(vouchersByStatus: any, view: any, closedStatus?: any) {
  if (!vouchersByStatus) return [];

  if (view === VOUCHER_PRIMARY_VIEWS.ACTIVE) {
    return vouchersByStatus.pending || [];
  }

  if (closedStatus) {
    return vouchersByStatus[closedStatus] || [];
  }

  return vouchersByStatus.closed || [];
}

/**
 * Returns the empty message for a given view and closed status.
 *
 * @param {'active' | 'closed'} view
 * @param {'approved' | 'rejected'} [closedStatus]
 * @returns {string}
 */
export function getEmptyMessage(view: any, closedStatus?: any) {
  if (view === VOUCHER_PRIMARY_VIEWS.ACTIVE) {
    return EMPTY_TABLE_MESSAGES[VOUCHER_PRIMARY_VIEWS.ACTIVE];
  }

  if (closedStatus) {
    return EMPTY_TABLE_MESSAGES[closedStatus] || 'No vouchers found';
  }

  return EMPTY_TABLE_MESSAGES[VOUCHER_PRIMARY_VIEWS.CLOSED] || 'No vouchers found';
}
